// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wu_a bih_b","TwoDimsListFeature__item":"wu_b bih_we","TwoDimsListFeature__item__text":"wu_c bih_vt"};